/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-menu.vue?vue&type=template&id=4e2f4cc2&scoped=true"
import script from "./pc-menu.vue?vue&type=script&lang=js"
export * from "./pc-menu.vue?vue&type=script&lang=js"
import style0 from "./pc-menu.vue?vue&type=style&index=0&id=4e2f4cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f4cc2",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn,QTabs,QTab,QSpace,QColor});
